import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupStoreRoutes: RouteRecordRaw = {
  path: '/setup/store',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.STORE_SETTINGS, path: '', component: () => import('./SetupStore.vue') },
  ],
};
